























































































































































































import axios from 'axios';
import i18n from 'vue-i18n';
import isEmail from 'validator/lib/isEmail';
import EventBus from '../../../eventBus';
import CoModal from '../co-modal/CoModal.vue';
import CoButton from '../../Atoms/co-button/CoButton.vue';
import CoTagList from '../co-TagList/coTagList.vue';
import CoText from '../../Atoms/co-text/CoText.vue';
import CoFormGroup from '../../Molecules/co-form-group/CoFormGroup.vue';
import CoInput from '../../Molecules/co-input/CoInput.vue';
import CoTable from '../../Molecules/co-table/CoTable.vue';
import CoLink from '@/components/Atoms/co-link/CoLink.vue';
import CoProgressBar from '@/components/Molecules/co-progress-bar/CoProgressBar.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoSharableInput from '../co-copy-sharable-input/CoSharableInput.vue';

const CSV_TEMPLATE_FILENAME = 'bulk-invite-template.csv';
const baseUrl = process.env.BASE_URL || '/';
const normalizedBaseUrl = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
const CSV_TEMPLATE_URL = `${normalizedBaseUrl}static/${CSV_TEMPLATE_FILENAME}`;

export default {
    name: 'CoUserInvite',
    components: {
        CoModal,
        CoButton,
        CoTagList,
        CoText,
        CoFormGroup,
        CoInput,
        CoTable,
        CoLink,
        CoProgressBar,
        CoHeadline,
        CoSharableInput,
    },
    props: {
        launchButtonLabel: {
            type: String,
            default: null,
        },
        launchButtonVariant: {
            type: String,
            default: 'primary',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        userLimitIsReached: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            email: null,
            emailList: [],
            loading: false,
            parsedCsvInvites: [],
            csvError: null,
            csvFileName: '',
            inviteLogs: [],
            previewItemsPerPage: 10,
            inviteLogItemsPerPage: 10,
            inviteProgress: {
                current: 0,
                total: 0,
            },
            inviteSendingFinished: false,
            baseUrl: window.location.origin,
        };
    },
    computed: {
        buttonLabel() {
            return this.launchButtonLabel || this.$t('labels.invite');
        },
        readyToSend() {
            return this.emailList.length > 0 || this.emailValid || this.parsedCsvInvites.length > 0 ? true : false;
        },
        emailValid() {
            return this.email ? this.isEmail(this.email) : false;
        },
        combinedEmails() {
            const manual = Array.isArray(this.emailList) ? this.emailList : [];
            const csvEmails = this.parsedCsvInvites.map((item) => item.email);
            const unique = Array.from(new Set([...manual, ...csvEmails]));
            return unique.filter((email) => this.isEmail(email));
        },
        sendButtonLabel() {
            const combinedCount = this.combinedEmails.length;
            const pendingCount = combinedCount || (this.emailValid ? 1 : 0);
            const normalizedCount = pendingCount > 0 ? pendingCount : 1;
            return this.$tc('coUserInvite.sendButtonLabel', normalizedCount, { count: normalizedCount });
        },
        csvTemplateUrl() {
            return CSV_TEMPLATE_URL;
        },
        csvPreviewColumns() {
            return [
                {
                    key: 'rowNumber',
                    title: this.$t('coUserInvite.csvPreviewNumberColumn'),
                    notSortable: true,
                    style: 'width: 80px',
                },
                {
                    key: 'email',
                    title: this.$t('coUserInvite.csvPreviewEmailColumn'),
                    notSortable: true,
                },
            ];
        },
        inviteLogColumns() {
            return [
                {
                    key: 'email',
                    title: this.$t('coUserInvite.csvPreviewEmailColumn'),
                    notSortable: true,
                },
                {
                    key: 'message',
                    title: this.$t('coUserInvite.inviteResultStatus'),
                    notSortable: true,
                },
            ];
        },
        showProgress() {
            return this.inviteProgress.total > 0;
        },
    },
    methods: {
        isEmail(email) {
            if (!email) {
                return false;
            }
            return isEmail(email);
        },
        show() {
            if (this.userLimitIsReached) {
                // trigger paywall
                EventBus.$emit('PAYWALL', {
                    feature: 'more-members',
                });
                return;
            }
            this.$refs.invitemodal.show();
        },
        tagsUpdatedHandler(event) {
            this.emailList = event;
        },
        triggerCsvSelect() {
            if (this.loading || this.disabled) {
                return;
            }
            const input = this.$refs.csvInput;
            if (input) {
                input.click();
            }
        },
        handleCsvInputKeydown(event) {
            if (!event) {
                return;
            }
            const actionableKeys = ['Enter', ' '];
            if (actionableKeys.includes(event.key)) {
                event.preventDefault();
                this.triggerCsvSelect();
            }
        },
        onCsvSelected(event) {
            const file = event && event.target ? event.target.files[0] : null;
            this.parsedCsvInvites = [];
            this.csvError = null;
            this.csvFileName = '';
            this.inviteLogs = [];
            if (!file) {
                if (event && event.target) {
                    event.target.value = '';
                }
                return;
            }
            const fileExtension = file.name ? file.name.split('.').pop().toLowerCase() : '';
            if (file.type && !file.type.includes('csv') && file.type !== 'text/plain' && fileExtension !== 'csv') {
                this.csvError = this.$t('coUserInvite.csvErrorInvalidType');
                if (event && event.target) {
                    event.target.value = '';
                }
                return;
            }
            this.csvFileName = file.name;
            const reader = new FileReader();
            reader.onload = (e) => {
                const text = e && e.target ? e.target.result : null;
                if (typeof text !== 'string') {
                    this.csvError = this.$t('coUserInvite.csvErrorRead');
                    return;
                }
                this.handleCsvContent(text);
            };
            reader.onerror = () => {
                this.csvError = this.$t('coUserInvite.csvErrorRead');
            };
            reader.readAsText(file);
            if (event && event.target) {
                event.target.value = '';
            }
        },
        handleCsvContent(content) {
            const lines = content.split(/\r?\n/).filter((line) => line.trim().length > 0);
            if (!lines.length) {
                this.csvError = this.$t('coUserInvite.csvErrorEmpty');
                return;
            }
            const firstRow = this.parseCsvLine(lines[0]);
            const emailHeaderIndex = firstRow.findIndex((cell) => cell.trim().toLowerCase() === 'email');
            const startIndex = emailHeaderIndex > -1 ? 1 : 0;
            const emailIndex = emailHeaderIndex > -1 ? emailHeaderIndex : 0;

            const invites = [];
            const seenEmails = new Set();
            for (let i = startIndex; i < lines.length; i += 1) {
                const row = this.parseCsvLine(lines[i]);
                const email = row[emailIndex] ? row[emailIndex].trim() : '';
                const normalizedEmail = email.toLowerCase();
                if (email && this.isEmail(email) && !seenEmails.has(normalizedEmail)) {
                    invites.push({
                        email,
                        rowNumber: i + 1,
                    });
                    seenEmails.add(normalizedEmail);
                }
            }

            if (!invites.length) {
                this.csvError = this.$t('coUserInvite.csvErrorNoEmails');
                return;
            }

            this.parsedCsvInvites = invites;
        },
        parseCsvLine(line) {
            const result = [];
            let current = '';
            let inQuotes = false;
            for (let i = 0; i < line.length; i += 1) {
                const char = line[i];
                if (char === '"') {
                    if (inQuotes && line[i + 1] === '"') {
                        current += '"';
                        i += 1;
                    } else {
                        inQuotes = !inQuotes;
                    }
                } else if (char === ',' && !inQuotes) {
                    result.push(current);
                    current = '';
                } else {
                    current += char;
                }
            }
            result.push(current);
            return result.map((item) => item.trim());
        },
        clearCsv() {
            this.parsedCsvInvites = [];
            this.csvError = null;
            this.csvFileName = '';
            this.inviteLogs = [];
            if (this.$refs.csvInput) {
                this.$refs.csvInput.value = '';
            }
        },
        async sendInvite() {
            if (this.loading) {
                return;
            }
            this.loading = true;
            if (this.emailValid) {
                this.$refs.emailList.addTag();
            }
            const emailsToSend = this.combinedEmails;
            if (!emailsToSend.length) {
                this.loading = false;
                return;
            }
            this.inviteLogs = [];
            this.inviteProgress.total = emailsToSend.length;
            this.inviteProgress.current = 0;
            for (let i = 0; i < emailsToSend.length; i += 1) {
                const email = emailsToSend[i];
                const logEntry = await this.sendSingleInvite(email);
                this.inviteLogs = [...this.inviteLogs, logEntry];
                this.inviteProgress.current = i + 1;
                if (i < emailsToSend.length - 1) {
                    await this.sleep(1000);
                }
            }
            const hasFailures = this.inviteLogs.some((log) => log.status === 'failed');
            if (hasFailures) {
                const hasSuccess = this.inviteLogs.some((log) => log.status === 'success');
                const msg = {
                    Message: hasSuccess
                        ? this.$t('coUserInvite.invitePartialError')
                        : this.$t('coUserInvite.inviteGeneralError'),
                    Details: '',
                };
                EventBus.$emit('ERROR', msg);
                this.$emit('invite-error');
            } else {
                const msg = {
                    Message: this.$t('coUserInvite.inviteSuccessMessage'),
                    Details: '',
                };
                EventBus.$emit('INFO', msg);
                this.$emit('invite-success');
            }
            this.loading = false;
            this.inviteSendingFinished = true;
        },
        async sendSingleInvite(email) {
            const data = {
                Emails: [{ Email: email }],
            };
            try {
                const response = await axios({
                    method: 'POST',
                    url: '/admin/member/invite/V2',
                    withCredentials: true,
                    data,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                const results = Array.isArray(response?.data?.Results) ? response.data.Results : null;
                const result = results && results.length ? results[0] : null;
                const success = result ? result.Success !== false : true;
                const normalizedEmail = result?.Email || result?.email || email;
                const message =
                    result?.Message ||
                    (success
                        ? this.$t('coUserInvite.inviteResultSuccess')
                        : this.$t('coUserInvite.inviteResultFailure'));
                return {
                    email: normalizedEmail,
                    status: success ? 'success' : 'failed',
                    message,
                };
            } catch (error) {
                const message =
                    (error &&
                        error.response &&
                        error.response.data &&
                        (error.response.data.Message || error.response.data.message)) ||
                    error.message ||
                    this.$t('coUserInvite.inviteGeneralError');
                return {
                    email,
                    status: 'failed',
                    message: message || this.$t('coUserInvite.inviteResultFailure'),
                };
            }
        },
        sleep(ms) {
            return new Promise((resolve) => {
                setTimeout(resolve, ms);
            });
        },
        resetModal() {
            this.email = null;
            this.emailList = [];
            this.loading = false;
            this.parsedCsvInvites = [];
            this.csvError = null;
            this.csvFileName = '';
            this.inviteLogs = [];
            this.resetProgress();
            if (this.$refs.csvInput) {
                this.$refs.csvInput.value = '';
            }
            if (this.$refs.invitemodal) {
                this.$refs.invitemodal.hide();
            }
        },
        resetProgress() {
            this.inviteProgress.current = 0;
            this.inviteProgress.total = 0;
        },
        downloadCsvTemplate() {
            const link = document.createElement('a');
            link.href = this.csvTemplateUrl;
            link.download = CSV_TEMPLATE_FILENAME;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
    },
};
